import React from "react";
import OpenHours from "./OpenHours";

//<figure><img src="/images/stock/photo-1606107557195-0e29a4b5b4aa.jpg" alt="car!"/></figure>


function Contact() {
    return(
        <div>
            <div className="card lg:card-side glass shadow-2xl hover:shadow-2xl">

                <div className="max-md:hidden inline"><figure><img src="/schild.jpg" alt="Praxisschild"/></figure></div>
                <div className="md:hidden"><figure><img src="/schild_small.jpg" alt="Praxisschild"/></figure></div>
                <div className="card-body">
                    <h2 className="card-title">Kontaktdaten</h2>
                    <p>Biebertalstraße 13–15
                    <br/>63599 Biebergemünd - Bieber <br></br>
                        Tel.: <a className="hover:underline " href="tel:060501516">06050-1516</a><br></br>
                    Fax.:  <a className="hover:underline " href="tel:060502051">06050-2051</a></p>
                    <h2 className="card-title">Für Rezepte</h2>
                    <p><a className="hover:decoration-pink-600 decoration-black text-blue-800 underline" rel="noreferrer" href="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin/patient-request?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin/patient-request-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin/patient-request" target="_blank">Auf Doctolib Folgerezept anfragen</a></p>
                </div>
            </div>
        </div>
    );
}

function Announcement() {
    return(
        <div className="card bg-red-400 shadow-2xl hover:shadow-2xl">
            <div className="card-body">
                <h1 className="card-title font-bold mb-2">Neue Rezeptemail</h1>
                <p>
                    Liebe Patient*innen: Wir führen eine neue Emailaddresse für Rezeptbestellungen ein.<br></br>
                    Benutzen Sie ab sofort bitte <a className="underline font-bold hover:decoration-pink-600 hover:text-pink-600 decoration-2 decoration-blue-800 text-blue-800" href="mailto:rezept@dr-bonin.de">rezept@dr-bonin.de</a> um Ihre Rezeptbestellungen zu tätigen.
                    Unsere alte Adresse wird ab sofort nicht mehr verwendet und wir können für Bestellungen über diese Adresse nicht garantieren, dass diese erfolgreich durchgehen.
                    <br></br><br></br>
                    Ihr Praxis-Team Dr. med. Thomas Bonin
                </p>
            </div>
        </div>
    );
}

function Rezeptbestellungen() {
    return(
        <div className="card bg-primary/50 shadow-2xl hover:shadow-2xl">
            <div className="card-body">
                 <div>
                     <h1 className="card-title font-bold mb-2">Rezeptbestellungen</h1>
                     <p>
                         Wir bieten Ihnen an Ihre Dauer-Rezepte per Doctolib, via Papiereinwurf oder per Rezept-Bestelltelefon via Mailbox für außerhalb der Sprechzeiten zu bestellen: <a className="font-bold hover:underline " href="tel:060506940977">06050-6940977</a>
                     </p>
                     <p>
                         Für Folge-/Dauerrezeptbestellungen navigieren sie hier bitte zu "Folgerezept anfragen" unter <a className="underline font-bold hover:decoration-pink-600 hover:text-pink-600 decoration-2 decoration-blue-800 text-blue-800" rel="noreferrer" href="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin/patient-request?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin/patient-request-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin/patient-request
" target="_blank">Doctolib's Nachrichtenfunktion</a> um ihre Rezeptbestellung zu tätigen.
                     </p>
                     <p>
                         Für die analogen Rezeptbestellungen, bitten wir sie folgendes <a className="underline font-bold hover:decoration-pink-600 hover:text-pink-600 decoration-2 decoration-blue-800 text-blue-800" target="_blank" href="/Rezeptbestellungsformular.pdf">Rezeptbestellformular</a> auszufüllen und in unseren Briefkasten einzuwerfen.
                     </p><br/>
                     <div>Bitte bestellen Sie Ihre Dauer-Rezepte und Überweisungen rechtzeitig vorher. Die Lieferung dauert gewöhnlich 2-3 Tage nach Ihrer Bestelllung. An Urlaubstagen und Feiertagen sind Rezeptbestellungen nicht verfügbar.</div>
                </div>
            </div>
        </div>
    );
}
export default function HomePage() {
    //const [openNav, setOpenNav] = React.useState(false);

    //React.useEffect(() => {
    //    window.addEventListener(
    //        "resize",
    //        () => window.innerWidth >= 960 && setOpenNav(false)
    //    );
    //}, []);

//space-x-4
    return (
        <div className="container flex-1 overflow-y-auto mx-auto px-8 py-8">
            <div className="">

                <div className="max-lg:hidden inline flex flex-row lg:bg-fixed rounded-md px-8 py-16" style={{
                    position:`relative`,
                    backgroundOrigin: `padding-box`,
                    backgroundImage: `url("website_banner.jpg")` }}>
                    <div className="hero-overlay bg-opacity-60"></div>
                    <div className="hero-content max-lg:hidden inline ">
                        <OpenHours/>
                    </div>
                </div>
                <div className="lg:hidden">
                    <OpenHours/>
                </div>
                <div className="py-4">
                    <Announcement/>
                </div>
                <div id="Rezeptbestellungen" className="py-4"></div>
                <div>
                    <Rezeptbestellungen/>
                    <div id="Kontakt" className="py-10"></div>
                    <Contact/>
                </div>
                <div className="py-10"></div>

            </div>
        </div>
    );
}

//function HomePage() {
//    return (
//        <div>
//            Among Us
//        </div>
//    )
//}

//export default HomePage
